<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Invoice_Num">Invoice Num</label>
              <ep-input
                myFocus
                name="Invoice_Num"
                [(ngModel)]="dsCollection.criteria.Invoice_Num"
                format="integer-10"
                (change)="model.dirty = true"
              ></ep-input>
            </div>
          </div>

          <div class="col-12 col-lg-8">
            <aurora-button
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              variant="primary"
              (click)="auroraSubmitForm.onSubmit($event)"
            >
              Search
            </aurora-button>
            <aurora-button
              class="pull-right margin-l-5"
              type="button"
              (click)="dsCollection.criteria.Invoice_ID = ''; model.dirty = true"
              style="margin-top: 16px"
              variant="secondary"
            >
              Reset
            </aurora-button>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #invoiceFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>
        <!--(itemChanged)="model.filter = $event"-->

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 700px">
            <tr>
              <th style="min-width: 100px">Invoice Num</th>
              <th style="min-width: 100px">Balance</th>
              <th style="min-width: 150px">Contract Num</th>
              <th style="min-width: 150px">Entity Name</th>
              <th style="min-width: 100px">Tran Date</th>
              <th style="min-width: 100px">Post Date</th>
            </tr>
            <tr
              *ngFor="
                let invoice of dsCollection.objectNodes
                  | epFilter : invoiceFilter.filter : invoiceFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(invoice)"
            >
              <td>
                {{ invoice.Invoice_Num }}
              </td>
              <td>
                {{ invoice.Current_Bal }}
              </td>
              <td>
                {{ invoice.Contract_Num }}
              </td>
              <td>
                {{ invoice.Entity_Name }}
              </td>
              <td>
                {{ invoice.Tran_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ invoice.Post_date | epDate : 'mm/dd/yy' }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Invoices</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
